/**
 * Reading Mode Toggle
 * Supports: light, dark, system (default)
 */

class ReadingMode {
  constructor() {
    this.storageKey = 'reading-mode';
    this.modes = ['light', 'dark', 'system'];
    this.currentMode = this.getStoredMode() || 'system';
    
    this.init();
  }

  init() {
    // Apply the stored mode on page load
    this.applyMode(this.currentMode);
    
    // Listen for system preference changes
    if (window.matchMedia) {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      mediaQuery.addEventListener('change', () => {
        if (this.currentMode === 'system') {
          this.applyMode('system');
        }
      });
    }

    // Setup dropdown
    this.setupDropdown();
  }

  getStoredMode() {
    try {
      return localStorage.getItem(this.storageKey);
    } catch (e) {
      return null;
    }
  }

  setStoredMode(mode) {
    try {
      localStorage.setItem(this.storageKey, mode);
    } catch (e) {
      // Ignore storage errors
    }
  }

  getSystemPreference() {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  }

  applyMode(mode) {
    const root = document.documentElement;
    
    // Remove all theme classes
    root.removeAttribute('data-theme');
    root.classList.remove('dark', 'light');
    
    if (mode === 'system') {
      const systemPref = this.getSystemPreference();
      if (systemPref === 'dark') {
        root.setAttribute('data-theme', 'dark');
        root.classList.add('dark');
      } else {
        root.setAttribute('data-theme', 'light');
        root.classList.add('light');
      }
    } else {
      root.setAttribute('data-theme', mode);
      root.classList.add(mode);
    }
  }

  setMode(mode) {
    if (!this.modes.includes(mode)) {
      return;
    }
    
    this.currentMode = mode;
    this.setStoredMode(mode);
    this.applyMode(mode);
    this.updateDropdown();
  }

  setupDropdown() {
    const select = document.getElementById('reading-mode-select');
    if (!select) {
      return;
    }

    // Set initial value from stored preference
    select.value = this.currentMode;

    // Listen for changes
    select.addEventListener('change', (e) => {
      this.setMode(e.target.value);
    });
  }

  updateDropdown() {
    const select = document.getElementById('reading-mode-select');
    if (select) {
      select.value = this.currentMode;
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.readingMode = new ReadingMode();
  });
} else {
  window.readingMode = new ReadingMode();
}

export default ReadingMode;

